
    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ScheduleFamilyManagementConference extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;
    
}
